<template>
  <div class="summary-page">
    <div class="summary-page-map">
      <div id="pageMap"></div>
      <!-- 统计数 -->
      <div class="page-overview-statistics">
        <div v-for="(item, index) in pageTopData" class="page-overview-statistics-top">
          <div class="page-overview-statistics-item">
            <div class="page-overview-statistics-item-number">{{item.value || 0}}</div>
            <div class="page-overview-statistics-item-tip">{{item.name}}</div>
          </div>
          <div class="page-overview-statistics-dividing-line" v-if="index !== 4 && index !== 9"></div>
        </div>
      </div>

      <!-- 底图表 -->
      <div class="page-overview-bottom-box">
        <!--<h3 style="text-align: left;padding: 0 0.6rem;">小区概况</h3>-->
        <div class="need-dealt-event-table">
          <div class="need-dealt-event-line need-dealt-event-head" style="height: 0.5rem">
            <div class="need-dealt-event-category" style="width: 18%">
              <span>小区名称</span>
            </div>
            <div class="need-dealt-event-description" style="width: 15%">
              <span>房源总数</span>
            </div>
            <div class="need-dealt-event-description" style="width: 15%">
              <span>入住人员数量</span>
            </div>
            <!--<div class="need-dealt-event-description" style="width: 12%">-->
              <!--<span>疑似转租</span>-->
            <!--</div>-->
            <div class="need-dealt-event-description" style="width: 15%">
              <span>入住房源数量</span>
            </div>
            <!--<div class="need-dealt-event-description" style="width: 11%">-->
              <!--<span>特殊人群</span>-->
            <!--</div>-->
            <div class="need-dealt-event-description" style="width: 15%">
              <span>接入设备</span>
            </div>
            <div class="need-dealt-event-occurTime" style="width: 15%">
              <span>报警次数</span>
            </div>
          </div>
          <div class="need-dealt-event-info record-table-list" id="suspectedSubleaseList">
            <div v-for="(park, parkIndex) in parkList" :key="parkIndex" class="need-dealt-event-line" @click="toPageOverviewParkInfo(park.shortName)">
              <div class="need-dealt-event-category" style="width: 18%">
                <span>{{park.communityName}}</span>
              </div>
              <div class="need-dealt-event-description" style="width: 15%">
                <span>{{park.roomNum}}</span>
              </div>
              <div class="need-dealt-event-description" style="width: 15%">
                <span>{{park.checkInPersonNum}}</span>
              </div>
              <div class="need-dealt-event-description" style="width: 15%">
                <span>{{park.checkInRoomNum}}</span>
              </div>
              <div class="need-dealt-event-description" style="width: 15%">
                <span>{{park.deviceNum}}</span>
              </div>
              <div class="need-dealt-event-occurTime" style="width: 15%">
                <span>{{park.alarmNum}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import UpperStrataCommonTop from '../UpperStrataCommonTop'
  import {api} from '../../api/Summary'
  import {bus} from '../../../utils/bus'
  import {errorHandler} from '../../../utils/errorHandler'

  export default {
    components: {UpperStrataCommonTop},
    name: 'summary-page',
    data () {
      return {
        map: null,
        longitude: 116.58,
        latitude: 35.42,

        parkList: [],

        pageTopData: [
          {name: '园区总数', type: 'communityNum', value: ''},
          {name: '楼栋总数', type: 'buildingNum', value: ''},
          {name: '房源总数', type: 'roomNum', value: ''},
          {name: '出租房源', type: 'checkInRoomNum', value: ''},
          {name: '空置房源', type: 'emptyRoomNum', value: ''},
          {name: '企业总数', type: 'enterpriseNum', value: ''},
          {name: '人员总数', type: 'checkInPersonNum', value: ''},
          {name: '总面积', type: 'roomArea', value: ''},
          {name: '出租面积', type: 'checkInRoomArea', value: ''},
          {name: '空置面积', type: 'emptyRoomArea', value: ''},
        ],

        groupHonorList: []
      }
    },
    created () {
      this.parkList = bus.global.upperData.yqAppCodeList
      this.getTotalCommunityInfo()
      this.getCommunityList()
      this.getGroupHonorList()
    },
    mounted () {
      this.$nextTick(() => {
        let th = this
        // 创建Map实例
        let map = new BMap.Map("pageMap");

        this.map = map
        // 初始化地图,设置中心点坐标，
        let top_right_navigation = new BMap.NavigationControl({anchor: BMAP_ANCHOR_TOP_RIGHT, type: BMAP_NAVIGATION_CONTROL_SMALL})
        this.map.addControl(top_right_navigation)

        let x = +this.longitude
        let y = +this.latitude

        let point = new BMap.Point(x, y);
        // // 创建点坐标
        this.map.centerAndZoom(point, 10);
        this.map.enableScrollWheelZoom();

        this.map.setMapStyleV2({
          styleId: '6a33a00a6daf059f1af971adc472ec5e'
        });

        setTimeout(() => {
          this.parkList.map((v, i) => {
            let pt = new BMap.Point(+v.longitude, +v.latitude)
            let myIcon = new BMap.Icon(require('../../../assets/position.png'), new BMap.Size(30,30));
            let marker2 = new BMap.Marker(pt,{icon:myIcon});  // 创建标注
            let steelContent = '<div><p style="margin: 0;line-height: 1.5;font-size: 12px;text-indent:2em"><br/>园区名称：'+ v.communityName +'<br/>纬度：'+ v.latitude +
              '<br/>经度：'+ v.longitude +'<br/><div style="text-align: right;padding: 0 10px;color: #00a0e6">查看详情</div></p></div>';
            let steelOpts = {
              width : 200,     //信息窗口宽度
              height: 150,     //信息窗口高度
              background: '#ffffff66',
              title : "<b>园区信息</b>" , //信息窗口标题
              enableMessage:true	//设置允许信息窗发送短息
            }
            marker2.addEventListener("click",function () {
                this.openInfoWindow(new BMap.InfoWindow(steelContent, steelOpts));
              }
            )
            this.map.addOverlay(marker2);              // 将标注添加到地图中
            // marker2.setAnimation(BMAP_ANIMATION_BOUNCE); //跳动的动画

            let label = new BMap.Label(v.communityName ,{offset:new BMap.Size(10, 35)});
            label.setStyle({
              color : "#00a0e6",
              fontSize : "10px",
              height : "20px",
              lineHeight : "20px",
              border: "none",
              background: "none",
              fontFamily:"微软雅黑",
            });
            marker2.setLabel(label);
          })
          // this.getCommunityList()
        }, 3000)
      })
    },
    methods: {
      // 获取信息
      getTotalCommunityInfo () {
        this.$axios.post(`${api.getTotalCommunityInfo}`, this.parkList)
          .then(res => {
            let data = res.data.data
            for (let i in data) {
              this.pageTopData.map(v => {
                if (i === v.type) {
                  v.value = data[i]
                }
              })
            }
          })
          .catch(errorHandler('获取信息失败'))
      },

      // 获取子园区列表
      getCommunityList () {
        this.$axios.post(`${api.getCommunityList}`, this.parkList)
          .then(res => {
            this.parkList = res.data.data
          })
          .catch(errorHandler('获取园区列表失败'))
      },

      // 获取集团荣誉列表
      getGroupHonorList () {
        this.$axios.post(`${api.getGroupHonorList}`, this.parkList)
          .then(res => {
            this.groupHonorList = res.data.data || []
          })
          .catch(errorHandler('获取园区列表失败'))
      }
    }
  }
</script>

<style>
  .anchorBL {
    display: none;
  }
</style>

<style scoped lang="less">
  .summary-page {
    height: 100%;
    flex: 1;
    min-height: 685px;
    background-color: #ffffff;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    color: #ffffff;
    .summary-page-map {
      flex: 1;
      height: 500px;
      position: relative;
      display: flex;
      justify-content: flex-start;
      #pageMap {
        flex: 1;
      }

      /* 顶部数据 */
      .page-overview-statistics {
        width: 10rem;
        position: absolute;
        top: 0.1rem;
        left: 0;
        right: 0;
        margin: 0 auto;
        border-radius: 0.1rem;
        padding: 0;
        border: 1px solid #2DC4BB;
        box-shadow:inset 0px 0px 6px 1px #2DC4BB;
        background: #2DC4BB33;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        align-items: center;
        .page-overview-statistics-top {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          align-items: center;
          width: 1.9rem;
        }
        .page-overview-statistics-dividing-line {
          width: 2px;
          height: 0.8rem;
          background-color: #2DC4BB;
          box-shadow:0 0 10px #2DC4BB;
        }
        .page-overview-statistics-item {
          flex: 1;
          display: flex;
          justify-content: center;
          flex-direction: column;
          padding: 0.1rem 0;
          text-align: center;
          color: #ffffff;
          .page-overview-statistics-item-number {
            font-weight: bold;
            font-size: 0.42rem;
            line-height: 0.64rem;
          }
          .page-overview-statistics-item-tip {
            font-size: 0.12rem;
            line-height: 0.36rem;
          }
        }
      }

      /* 底部图表 */
      .page-overview-bottom-box {
        width: 26rem;
        height: 4rem;
        padding: 0.2rem;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0.2rem;
        margin: 0 auto;
        background-color: #2DC4BB33;
        border: 2px solid #2DC4BB;
        border-radius: 0.1rem;
        box-shadow:inset 0px 0px 6px 2px #2DC4BB;
        /*background: url("../../assets/centre_top2.png");*/
        /*background-size: 100% 100%;*/
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        .need-dealt-event-table {
          overflow: hidden;
          flex: 1;
          height: 90%;
          padding: 0.2rem 0.5rem;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          .need-dealt-event-head {
            font-weight: bold;
            font-size: 0.28rem;
            border-bottom: none!important;
            .need-dealt-event-category:before, .need-dealt-event-description:before, .need-dealt-event-occurTime:before {
              content: '';
              position: absolute;
              top: 0;
              right: 0;
              bottom: 0;
              left: 0;
              z-index: -1;
              transform: skewX(-30deg);
              /*background-image: url("../../assets/record_table_title_bg.png");*/
              /*background-size: 100% 100%;*/
            }
          }
          .need-dealt-event-info {
            flex: 1;
            overflow-y: auto;
          }
          .need-dealt-event-line {
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            height: 0.6rem;
            border-bottom: 1px solid #2DC4BB99;
            .need-dealt-event-category {
              flex: 1;
              position: relative;
              z-index: 1;
              width: 29%;
              margin-right: 0.1rem;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            .need-dealt-event-description {
              position: relative;
              z-index: 1;
              width: 39%;
              margin-right: 0.1rem;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            .need-dealt-event-occurTime {
              position: relative;
              z-index: 1;
              width: 30%;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            span {
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
    }

    ::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 5px #2DC4BB!important;
      background: #2DC4BB!important;
    }

    ::-webkit-scrollbar-track {/*滚动条里面轨道*/
      -webkit-box-shadow: inset 0 0 5px #2DC4BB99!important;
      border-radius: 10px;
      background: #EDEDED;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/UpperStrata/Summary/SummaryPage.vue